// extracted by mini-css-extract-plugin
export default {"ellipsis":"AnimationsEllipsis_ellipsis__kZwaX"};